const offlineMeanCodes = ['check', 'mandate', 'transfer'];
export const useOfflineMean = order => {
  return !!(order && offlineMeanCodes.includes(order.payment_type));
};